<template>
  <ul class='pt-8'>
    <li v-for='(item, index) in list' :key='index' class='fs-12 lh-14 mt-12'>
      <a :href="item.url" class="sub-link">{{item.title}}</a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'DropDown',
  props: ['list']
}
</script>

<style scoped lang="scss">
  // v2 §Header Nav sub-link — ink at rest, plain green over 200ms on hover (no underline)
  .sub-link {
    color: $foreground;
    transition: color $dur-base $ease-out; // 200ms hover
    @include focus-ring; // v2 §14 GREEN keyboard ring (was gold)
    &:hover { color: $link; }
  }
</style>
